import { render } from "./Footer.vue?vue&type=template&id=20938991&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=20938991&scoped=true&lang=scss"
import "./Footer.vue?vue&type=style&index=1&id=20938991&scoped=true&lang=scss"
import "./Footer.vue?vue&type=style&index=2&id=20938991&scoped=true&lang=scss"
import "./Footer.vue?vue&type=style&index=3&id=20938991&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20938991"]])

export default __exports__